import { render, staticRenderFns } from "./AlarmHistory.vue?vue&type=template&id=96576734&scoped=true&"
import script from "./AlarmHistory.vue?vue&type=script&lang=ts&"
export * from "./AlarmHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmHistory.vue?vue&type=style&index=0&id=96576734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96576734",
  null
  
)

component.options.__file = "AlarmHistory.vue"
export default component.exports